import { memo } from 'react';
import { Flex, Text } from '@chakra-ui/react';

import { BUILDER_MODE_V1_LAYOUT, BUILDER_MODE_V1_TOKENS } from '../../constants';

import ExpandViewIcon from './ExpandViewIcon';

export interface InputPanelExpandedViewButtonV1Properties {
  isExpanded: boolean;
  onClick: () => void;
}

const InputPanelExpandedViewButtonV1 = memo(
  ({ isExpanded, onClick }: InputPanelExpandedViewButtonV1Properties) => (
    <Flex
      as='button'
      type='button'
      align='center'
      gap='12px'
      bg='transparent'
      border='none'
      p={0}
      cursor='pointer'
      onClick={onClick}
      aria-label={isExpanded ? 'Collapse view' : 'Expand view'}
    >
      <Text
        fontFamily={BUILDER_MODE_V1_LAYOUT.toolbarFontFamily}
        fontSize='14px'
        fontWeight='500'
        lineHeight='normal'
        color={BUILDER_MODE_V1_TOKENS.textDark}
        whiteSpace='nowrap'
      >
        {isExpanded ? 'Collapsed View' : 'Expanded View'}
      </Text>
      <ExpandViewIcon />
    </Flex>
  ),
);

InputPanelExpandedViewButtonV1.displayName = 'InputPanelExpandedViewButtonV1';

export default InputPanelExpandedViewButtonV1;
